import Enum from "./Enum";

const EnumGender = new Enum({
    MALE: "Male",
    FEMALE: "Female"
});

export default EnumGender;